import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext, ThemeMode } from '../../contexts/ThemeContext';
import { SunIcon, MoonIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';

const ThemeSelector: React.FC = () => {
  const { themeMode, setThemeMode } = useContext(ThemeContext);
  const { t } = useTranslation();

  const handleThemeChange = (mode: ThemeMode) => {
    setThemeMode(mode);
  };

  return (
    <div className="flex flex-col space-y-2 p-2 rounded-lg bg-white dark:bg-gray-800 shadow">
      <span className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        {t('settings.theme')}:
      </span>
      <div className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2">
        <button
          className={`flex items-center justify-center px-3 py-2 rounded-md transition-colors ${
            themeMode === 'light'
              ? 'bg-domired-600 text-white'
              : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }`}
          onClick={() => handleThemeChange('light')}
          aria-label={t('settings.lightMode')}
        >
          <SunIcon className="h-5 w-5 mr-2" />
          <span>{t('settings.lightMode')}</span>
        </button>
        <button
          className={`flex items-center justify-center px-3 py-2 rounded-md transition-colors ${
            themeMode === 'dark'
              ? 'bg-domired-600 text-white'
              : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }`}
          onClick={() => handleThemeChange('dark')}
          aria-label={t('settings.darkMode')}
        >
          <MoonIcon className="h-5 w-5 mr-2" />
          <span>{t('settings.darkMode')}</span>
        </button>
        <button
          className={`flex items-center justify-center px-3 py-2 rounded-md transition-colors ${
            themeMode === 'system'
              ? 'bg-domired-600 text-white'
              : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }`}
          onClick={() => handleThemeChange('system')}
          aria-label={t('settings.systemDefault')}
        >
          <ComputerDesktopIcon className="h-5 w-5 mr-2" />
          <span>{t('settings.systemDefault')}</span>
        </button>
      </div>
    </div>
  );
};

export default ThemeSelector;
